import request from '@/api/http'

const project = {
    // post提交
    getProjectConfigList(params, callback) {
        let callbackInterceptor = (data, outSideData) => {
            if (data === 'fail') {
                callback(data, outSideData)
            } else {
                callback(data.map(item => {
                    item.projectManager = item.projectManager ? item.projectManager : item.projectRelList[0] ? item.projectRelList[0].employeeName : '暂无绑定主管';
                    return item
                }), outSideData)
            }
        }
        return request.post(process.env.BASE_URL + `/project/getProjectConfigList`, params, callbackInterceptor)
    },
    // 获取甲方公司列表
    getOwnerCompanyList(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getOwnerCompanyList`, params, callback)
    },
    getProjectNews(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getProjectNews`, params, callback)
    },
    updateProjectConfig(params, callback) {
        return request.post(process.env.BASE_URL + `/project/updateProjectConfig`, params, callback)
    },
    updateProjectSite(params, callback) {
        params.method = "PUT"
        return request.post(process.env.BASE_URL + `/project/updateProjectSite`, params, callback)
    },
    addProjectApply(params, callback) {
        return request.post(process.env.BASE_URL + `/project/addProjectApply`, params, callback)
    },
    getApplyProjectList(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getApplyProjectList`, params, callback)
    },
    getAuditProjectList(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getAuditProjectList`, params, callback)
    },
    projectAudit(params, callback) {
        return request.post(process.env.BASE_URL + `/project/projectAudit`, params, callback)
    },
    projectSignOutApply(params, callback) {
        return request.post(process.env.BASE_URL + `/project/projectSignOutApply`, params, callback)
    },
    addServiceMargin(params, callback) {
        return request.post(process.env.BASE_URL + `/project/addServiceMargin`, params, callback)
    },
    getWorkProcessList(params, callback) {
        return request.post(process.env.BASE_URL + `/lvjing/flow/process/initiator`, params, callback)
    },
    getWorkCcProcessList(params, callback) {
        return request.post(process.env.BASE_URL + `/lvjing/flow/task/ccList`, params, callback)
    },
    getWaitProcessList(params, callback) {
        return request.post(process.env.BASE_URL + `/lvjing/flow/task/assigned`, params, callback)
    },
    processDetail(params, callback) {
        return request.post(process.env.BASE_URL + `/project/processDetail`, params, callback)
    },
    //ss
    getProjectBaseNews(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getProjectBaseNews`, params, callback)
    },
    getLastProjectContractNews(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getLastProjectContractNews`, params, callback)
    },
    getProjectOverview(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getProjectOverview`, params, callback)
    },
    getOverviewMap(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getOverview`, params, callback)
    },
    getEmployeeOverview(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getEmployeeOverview`, params, callback)
    },
    getRepairList(params, callback) {
        return request.get(process.env.BASE_URL + `/equipment/repair/pageList`, params, callback)
    },
    getProjectList(params, callback) {
        return request.post(process.env.BASE_URL + `/project/getProjectList`, params, callback)
    },
    getBudgetAndDetailList(params, callback) {
        return request.post(process.env.BASE_URL + '/project/getBudgetAndDetailList', params, callback)
    },
    getReceivableMonthlyDetail(params, callback) {
        return request.get(process.env.BASE_URL + `/project/getReceivableMonthlyDetail`, params, callback)
    },
    // 添加、确认、修改应收款
    confirmReceivableMonthly(params, callback) {
        return request.post(process.env.BASE_URL + '/project/confirmReceivableMonthly', params, callback)
    },
    // 保存预估应收款
    saveReceivableMonthlyEstimate(params, callback) {
        return request.post(process.env.BASE_URL + '/project/saveReceivableMonthlyEstimate', params, callback)
    },
}

export default project
